/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
/* eslint-disable ember/require-computed-property-dependencies */
import { get, computed } from '@ember/object';
import { map, filterBy, readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import Predicate from 'predicates/models/predicate';
import { readsAndFmtWithProperty } from '@intercom/pulse/lib/computed-properties';
import { ConversationState, ConversationStarter } from 'embercom/objects/inbox/conversation';
import { CURRENT_TEAMMATE_PLACEHOLDER_ID, CURRENT_TEAMMATE_TRANSLATION_KEY } from 'embercom/lib/inbox/constants';
import { TicketCategory } from 'embercom/objects/inbox/ticket';
import { Channel, CHANNEL_NAME_TRANSLATION_KEYS, CHANNEL_NAME_TRANSLATION_KEYS_STANDALONE, getUnsupportedChannelsForPredicates } from 'embercom/models/data/inbox/channels';
const NULL_VALUE_COMPARISONS = ['known', 'unknown'];
const TEAM_ADMIN_TYPE = 'team';
export default Predicate.extend({
  store: service(),
  appService: service(),
  ticketStateService: service(),
  intl: service(),
  genericType: 'optionalSelect',
  isEditable: true,
  isOptionalSelectType: true,
  groupedItemTypes: ['rules_filters_assign_to', 'custom_state_id'],
  defaultInComparisonTypes: ['rating_requested_for_actor'],
  defaultKnownComparisonTypes: ['rules_filters_assign_to', 'rules_filters_manual_tag', 'rules_filters_apply_conversation_sla'],
  defaultComparison: computed(function () {
    if (this.defaultKnownComparisonTypes.includes(this.type)) {
      return 'known';
    } else if (this.defaultInComparisonTypes.includes(this.type)) {
      return 'in';
    } else {
      return 'eq';
    }
  }),
  name: computed('info?.name', 'attributeIdentifier', 'intl.locale', function () {
    if (this.attributeIdentifier === 'conversation.rating_requested_for_actors') {
      return this.intl.t('common.predicates.participant-conversation-attributes.csat-rating-requested-for-agent.attribute-name-at-edit');
    }
    return this.info?.name;
  }),
  getDefaultValue(context) {
    if (this.defaultKnownComparisonTypes.includes(this.type) && context?.isCreatingPredicate && this.defaultComparison === 'known') {
      return null;
    }
    if (this.groupedItemTypes.includes(this.type)) {
      return this.options.firstObject.items.firstObject.value;
    }
    return this.get('options.firstObject.value');
  },
  emptyState: readsAndFmtWithProperty('%@EmptyState', 'camelizedType'),
  options: readsAndFmtWithProperty('%@Options', 'camelizedType'),
  planOptions: map('appService.app.plans', function (plan) {
    return {
      label: get(plan, 'name'),
      value: get(plan, 'id')
    };
  }),
  accounts: filterBy('appService.app.accounts', 'deleted', false),
  accountIdOptions: map('accounts', function (account) {
    return {
      label: get(account, 'name'),
      value: get(account, 'id')
    };
  }),
  accountIdEmptyState: {
    title: 'There are no accounts available',
    icon: 'briefcase'
  },
  assignableAdmins: computed('intl.locale', 'info', 'appService.app.admins', function () {
    let adminType = this.info?.adminType;
    let assignees;
    if (adminType) {
      let findTeamAdmins = adminType === TEAM_ADMIN_TYPE;
      assignees = this.appService.app.admins.filterBy('isTeam', findTeamAdmins);
      if (this.appService.app.canAssignToTeamAndTeammate && adminType === TEAM_ADMIN_TYPE) {
        let unassigned = this.appService.app.admins.findBy('isUnassignedAdmin', true);
        assignees = [unassigned, ...assignees];
      }
    } else {
      assignees = this.appService.app.admins;
    }
    if (this.appService.app.canUseFeature('inbox_dynamic_views')) {
      // This is the list that loads in the assignee dropdown for view filters
      assignees.splice(2, 0, {
        name: this.intl.t(CURRENT_TEAMMATE_TRANSLATION_KEY),
        id: CURRENT_TEAMMATE_PLACEHOLDER_ID
      });
    }
    return assignees;
  }),
  allAdmins: computed('info', 'appService.app.admins', function () {
    let allAdmins = this.appService.app.admins;
    let allAdminAccounts = allAdmins.filterBy('isTeam', false).filter(admin => !(admin.name === 'Unassigned'));
    return allAdminAccounts;
  }),
  owners: filterBy('appService.app.assignableAdminsWithoutUnassigned', 'isTeam', false),
  ownerIdOptions: map('owners', function (admin) {
    return {
      label: get(admin, 'name'),
      value: get(admin, 'id')
    };
  }),
  adminAssigneeIdOptions: map('assignableAdmins', function (admin) {
    let label = get(admin, 'name');
    let value = get(admin, 'id');
    if (this.appService.app.canAssignToTeamAndTeammate && admin.isUnassignedAdmin) {
      label = 'None';
    }
    return {
      label,
      value
    };
  }),
  teamAssigneeIdOptions: readOnly('adminAssigneeIdOptions'),
  adminIdOptions: map('allAdmins', function (admin) {
    let label = get(admin, 'name');
    let value = get(admin, 'id');
    return {
      label,
      value
    };
  }),
  ratingRequestedForActorOptions: computed('intl.locale', function () {
    return [{
      label: this.intl.t('common.predicates.participant-conversation-attributes.csat-rating-requested-for-agent.type.teammate'),
      value: 'human',
      icon: 'person'
    }, {
      label: this.intl.t('common.predicates.participant-conversation-attributes.csat-rating-requested-for-agent.type.fin-ai-agent'),
      value: 'ai_agent',
      icon: 'fin'
    }, {
      label: this.intl.t('common.predicates.participant-conversation-attributes.csat-rating-requested-for-agent.type.chatbot'),
      value: 'workflow',
      icon: 'workflows'
    }];
  }),
  createdByIdOptions: computed('appService.app.admins', function () {
    return this.appService.app.admins.map(admin => {
      return {
        label: get(admin, 'name'),
        value: get(admin, 'id')
      };
    });
  }),
  categoryName(category) {
    switch (category) {
      case TicketCategory.Request:
        return this.intl.t('operator.workflows.visual-builder.send-ticket-menu.category.request');
      case TicketCategory.Task:
        return this.intl.t('operator.workflows.visual-builder.send-ticket-menu.category.task');
      case TicketCategory.Tracker:
        return this.intl.t('operator.workflows.visual-builder.send-ticket-menu.category.tracker');
    }
  },
  ticketTypeIdOptions: computed('intl.locale', function () {
    let ticketTypes = this.store.peekAll('inbox/ticket-type');
    return ticketTypes.filter(ticketType => !ticketType.archived || ticketType.id === this.value).sortBy('name').map(({
      name,
      id,
      emojiUri,
      category
    }) => ({
      label: name,
      value: id,
      emojiUri,
      category: this.categoryName(category),
      component: 'common/select-ticket-type-item'
    }));
  }),
  ticketTypeIdEmptyState: computed('intl.locale', function () {
    return {
      title: this.intl.t('settings.inbox-rules.empty-state.ticket-types.title'),
      icon: 'attention',
      description: this.intl.t('settings.inbox-rules.empty-state.ticket-types.description')
    };
  }),
  ticketStateOptions: computed('intl.locale', function () {
    return [{
      label: this.intl.t('inbox.ticket-state.submitted'),
      value: 'submitted'
    }, {
      label: this.intl.t('inbox.ticket-state.in_progress'),
      value: 'in_progress'
    }, {
      label: this.intl.t('inbox.ticket-state.waiting_on_customer'),
      value: 'waiting_on_customer'
    }, {
      label: this.intl.t('inbox.ticket-state.resolved'),
      value: 'resolved'
    }];
  }),
  customStateIdOptions: computed('ticketStateService.customStates', function () {
    return this.ticketStateService.getGroupedCustomStatesForDropdown(this.ticketStateService.liveTicketCustomStates);
  }),
  channelOptions: computed('intl.locale', 'appService', function () {
    let unsupportedChannels = getUnsupportedChannelsForPredicates(this.appService);

    // Use standalone-specific translation keys for standalone apps
    let translationKeys = this.appService.app?.canUseStandalone ? CHANNEL_NAME_TRANSLATION_KEYS_STANDALONE : CHANNEL_NAME_TRANSLATION_KEYS;
    return Object.values(Channel).filter(value => {
      return typeof value === 'number' && !unsupportedChannels.includes(value);
    }).map(channel => ({
      label: this.intl.t(translationKeys[channel]),
      value: channel.toString()
    }));
  }),
  conversationStateOptions: computed(function () {
    return Object.keys(ConversationState).map(key => ({
      label: key,
      value: `state_${ConversationState[key]}`
    }));
  }),
  conversationTopicOptions: computed(function () {
    let topics = this.store.peekAll('conversational-insights/conversation-topic');
    return topics.sortBy('name').map(({
      id,
      name
    }) => ({
      label: name,
      value: id
    }));
  }),
  conversationStartedByOptions: computed(function () {
    return [{
      value: ConversationStarter.User,
      label: 'Customer message'
    }, {
      value: ConversationStarter.AdminDirectMessageToOne,
      label: 'Teammate sending direct message'
    }, {
      value: ConversationStarter.AdminDirectMessageToMany,
      label: 'Teammate sending to many customers'
    }, {
      value: ConversationStarter.CustomBot,
      label: 'Workflow'
    }, {
      value: ConversationStarter.OtherOutbound,
      label: 'Outbound message'
    }];
  }),
  sentimentOptions: computed(function () {
    return [{
      value: 'positive',
      label: 'Positive'
    }, {
      value: 'neutral',
      label: 'Neutral'
    }, {
      value: 'negative',
      label: 'Negative'
    }];
  }),
  whatsappIntegrationIdOptions: computed(function () {
    let whatsappIntegrations = this.store.peekAll('whatsapp/integration');
    return whatsappIntegrations.sortBy('displayName').map(integration => ({
      label: integration.displayString,
      value: integration.id
    }));
  }),
  whatsappIntegrationIdEmptyState: computed('intl.locale', function () {
    return {
      title: this.intl.t('settings.inbox-rules.empty-state.whatsapp'),
      icon: 'briefcase'
    };
  }),
  instagramIntegrationIdOptions: computed(function () {
    let instagramIntegrations = this.store.peekAll('instagram/integration');
    return instagramIntegrations.sortBy('displayString').map(integration => ({
      label: integration.displayString,
      value: integration.id
    }));
  }),
  instagramIntegrationIdEmptyState: computed('intl.locale', function () {
    return {
      title: this.intl.t('settings.inbox-rules.empty-state.instagram'),
      icon: 'briefcase'
    };
  }),
  brandNameOptions: computed(function () {
    let brands = this.store.peekAll('messenger-settings/look-and-feel').firstObject?.brands.map(brand => ({
      value: brand.get('brandName'),
      label: brand.get('brandName')
    }));
    return brands || [];
  }),
  browserLocaleOptions: map('appService.app.browser_locales', function (locale) {
    return {
      label: get(locale, 'name'),
      value: get(locale, 'locale_id')
    };
  }),
  tags: readOnly('appService.app.tags'),
  optionalManualTagOptions: computed('tags.[]', 'value', function () {
    let app = this.appService.app;
    let tags = app.tags;
    tags = tags.reject(tag => tag.archived && tag.id.toString() !== this.value?.toString());
    return tags.map(tag => ({
      label: get(tag, 'name'),
      value: get(tag, 'id')
    }));
  }),
  rulesFiltersManualTagOptions: readOnly('optionalManualTagOptions'),
  rulesFiltersAssignToOptions: computed('assignableAdmins', function () {
    let getAdmin = admin => ({
      label: get(admin, 'name'),
      value: get(admin, 'id'),
      component: 'common/avatar-and-name-dropdown-item',
      componentAttrs: {
        model: admin,
        modelDisplayName: get(admin, 'name'),
        avatarSize: 'xs'
      }
    });
    return [{
      heading: 'Teams',
      items: this.assignableAdmins.filter(admin => get(admin, 'isTeam')).map(getAdmin)
    }, {
      heading: 'Teammates',
      items: this.assignableAdmins.filter(admin => !get(admin, 'isTeam')).map(getAdmin)
    }];
  }),
  conversationSlas: computed('info', 'appService.app', function () {
    let slas = this.store.peekAll('inbox/conversation-sla').toArray();
    return slas;
  }),
  rulesFiltersApplyConversationSlaOptions: computed('conversationSlas.[]', function () {
    return this.conversationSlas.map(sla => ({
      label: sla.name,
      value: sla.id
    }));
  }),
  rulesFiltersApplyConversationSlaEmptyState: {
    title: 'There are no SLAs available',
    icon: 'delivery-window'
  },
  conversationAttributeListOptions: computed('attributeIdentifier', function () {
    let identifierDetails = this.attributeIdentifier.split('.');
    let descriptorId = identifierDetails.pop();
    let attributeDescriptor;
    if (descriptorId) {
      attributeDescriptor = this.store.peekRecord('conversation-attributes/descriptor', descriptorId);
    }
    let options = attributeDescriptor?.listOptions.filter(listOption => !listOption.archived || listOption.id === this.value).map(listOption => ({
      label: listOption.label,
      value: listOption.listOptionId
    }));
    return options || [];
  }),
  attributeDescriptorListOptions: computed('attributeIdentifier', function () {
    let identifierDetails = this.attributeIdentifier.split('.');
    let descriptorId = identifierDetails.pop();
    let attributeDescriptor = this.store.peekRecord('objects/attribute-descriptor', descriptorId);
    let options = attributeDescriptor?.listOptions.filter(option => !option.archived || option.id === this.value).map(option => ({
      label: option.label,
      value: option.id
    }));
    return options || [];
  }),
  workflowAttributeDescriptorListOptions: computed('attributeIdentifier', function () {
    let identifierDetails = this.attributeIdentifier.split('.');
    let descriptorId = identifierDetails.pop();
    let attributeDescriptor = this.store.peekRecord('operator/visual-builder/attribute-descriptor', descriptorId);
    let options = attributeDescriptor?.listOptions.filter(option => !option.archived || option.id === this.value).map(option => ({
      label: option.label,
      value: option.id
    }));
    return options || [];
  }),
  _initializeValueForComparison(comparison) {
    if (NULL_VALUE_COMPARISONS.includes(comparison)) {
      return null;
    } else if (this.hasNoValue) {
      return this.getDefaultValue();
    } else {
      return this.value;
    }
  },
  isInvalid: computed('isValid', 'isInvalidOptionSelected', function () {
    return !this.isValid || this.isInvalidOptionSelected;
  }),
  areOptionsGrouped: computed('options', function () {
    return this.options.every(option => option.items);
  }),
  isInvalidOptionSelected: computed('options', 'value', function () {
    if (this.hasNoValue) {
      return false;
    }
    let optionValues = this.options.map(option => option.value);
    if (this.areOptionsGrouped) {
      optionValues = this.options.map(option => option.items).flat().map(item => item.value);
    }
    return !optionValues.includes(this.value);
  }),
  predicateValue: computed('value', function () {
    if (this.isInvalidOptionSelected) {
      return undefined;
    }
    return this.value;
  })
});